module.exports = __webpack_public_path__ + "static/media/boglioli.10f9987f.jpg";